// Чистит пустые ключи

export default (o = {}) => Object.keys(o).reduce((acc, key) => {
  if (o[key] || typeof o[key] === 'boolean') acc[key] = o[key];
  return acc;
}, {});
